module.exports = __webpack_public_path__ + "media/backgrounds/dog-profile-polaroid-frame-ea94c2c9.svg";